import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const listSx: SxProps<Theme> = {
    padding: 0,
};

export const listItemSx: SxProps<Theme> = {
    borderRadius: theme.spacing(8 / 8),
    marginBottom: theme.spacing(8 / 8),
    backgroundColor: theme.palette.neutral[50],
    '&:hover': {
        backgroundColor: theme.palette.neutral[100],
    },
};

export const emptyStateSx: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(5),
    minHeight: 100,
};

export const loadingWrapperSx: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(40 / 8),
};